import { Injectable } from '@angular/core';
import { ExerciceRow, ExercicesProvider } from '../../exercices/providers/exercices-provider';
import { HistogramData, SessionRow } from './sessions-provider';
import { SessionItemRightsList, SessionRights } from './session-rights';
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { ConfigProvider } from "../../config-provider.service";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { LangsProvider } from "../../common/providers/langs-provider";
import { CurrentUser } from "../../common/providers/current-user";
import { SessionItemWrapper, SessionItemWrapperData } from "../../common/models/session-item-wrapper";
import { SessionItemExercice, SessionItemExerciceData } from "../../common/models/session-item-exercice";
import { SessionItem, SessionItemData } from "../../common/models/session-item";
import { Organization } from "../../common/models/organization";
import { Exercice } from "../../common/models/exercice";
import { User } from "../../common/models/user";
import { Session } from '../../common/models/session';
import { forkJoin, Observable, of, switchMap } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ExerciceCategory } from "../../common/models/exercice-category";
import { Paginator } from "../../common/models/paginator";


@Injectable({providedIn: 'root'})
export class SessionItemsProvider {
  public static readonly TYPE_BLOC = SessionItemWrapper.TYPE_BLOC;
  public static readonly TYPE_EXERCICE = SessionItemExercice.TYPE_EXERCICE;
  public static readonly TYPE_REST = SessionItem.TYPE_REST;
  public static readonly TYPE_COMMENT = SessionItem.TYPE_COMMENT;

  public static readonly DROPZONES: Map<string, string[]> = new Map([

    [SessionItemsProvider.TYPE_BLOC, ['root']],
    [SessionItemsProvider.TYPE_EXERCICE, ['bloc']],
    [SessionItemsProvider.TYPE_REST, ['root', 'bloc']],
    [SessionItemsProvider.TYPE_COMMENT, ['root', 'bloc']],

  ]);
  public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));

  private sessionRights: SessionRights = new SessionRights(this._utils);

  constructor(
    private _conf: ConfigProvider,
    private _utils: UtilsProvider,
    private api: ApiBaseService,
    private _langs: LangsProvider,
    private _currentUser: CurrentUser,
    private _exercicesProvider: ExercicesProvider,
    private _currentUserRoles: CurrentUserRolesProvider,
  ) {

    this.Ready = new Promise((resolve, reject) => {

      this._exercicesProvider.Ready.then(() => {
        resolve(true);
      })
        .catch(reject);

    });

  }

  public getSessionExercices(sessionId: number): Promise<SessionItemExercice[]> {
    return this.api.call('get', 'users/sessions/session-items/exercices/' + sessionId, {}, this._currentUser.getAccessToken()).toPromise();
  }

  public getSessionItemByWrapper(itemWrapperId: number): Promise<SessionItem> {
    return this.api.call('get', 'users/sessions/session-items/' + itemWrapperId, {}, this._currentUser.getAccessToken()).toPromise();
  }

  public getSessionItemsByWrapper(itemWrapperId: number, withTrashed: boolean = false): Observable<SessionItem[]> {
    const params = {
      with_trashed: withTrashed ? 'true' : 'false'
    }
    return this.api.call('get', 'users/sessions/session-items/by-wrapper/' + itemWrapperId, params, this._currentUser.getAccessToken()).pipe(
      map((data: SessionItemData[]) => SessionItem.fromAPIList(data)),
    );
  }

  public getSessionItemExerciceByWrapper(itemWrapperId: number): Promise<SessionItemExercice> {
    return this.api.call('get', 'users/sessions/session-items/exercice/' + itemWrapperId, {}, this._currentUser.getAccessToken()).toPromise();
  }

  public getSessionItemExercicesByWrapper(itemWrapperId: number, withTrashed: boolean = false): Observable<SessionItemExercice[]> {
    const params = {
      with_trashed: withTrashed ? 'true' : 'false'
    }
    return this.api.call('get', 'users/sessions/session-items/exercices/by-wrapper/' + itemWrapperId, params, this._currentUser.getAccessToken()).pipe(
      map((data: SessionItemExerciceData[]) => SessionItemExercice.fromAPIList(data)),
    );
  }

  public getSessionItemWrappersBySession(sessionId: number, withTrashed: boolean = false): Observable<SessionItemWrapper[]> {
    const params = {
      with_trashed: withTrashed ? 'true' : 'false'
    }
    return this.api.call('get', 'users/sessions/session-items/wrappers/' + sessionId, params, this._currentUser.getAccessToken()).pipe(
      map((data: SessionItemWrapperData[]) => SessionItemWrapper.fromAPIList(data)),
    );
  }

  public duplicateSessionItem(toDuplicate: SessionItemRow): SessionItemRow {
    // on fait tout ce tsointsoin avec les droits pour éviter les erreurs de clonages
    // (circular reference)
    let originalRights = null;
    if (toDuplicate.data && toDuplicate.data.exercice) {
      originalRights = toDuplicate.data.exercice.rights;
      delete toDuplicate.data.exercice.rights;
    }
    const originalInnerElements = toDuplicate.innerElements;
    toDuplicate.innerElements = [];
    const toReturn = JSON.parse(JSON.stringify(toDuplicate));

    if (originalRights) {
      toDuplicate.data.exercice.rights = originalRights;
      toReturn.data.exercice.rights = originalRights; // bad practice !!!!!
      // mais c'est 1000 fois plus simple
      // et je vois pas de scénario où c'est problématique ...
    }
    toReturn.innerElements = [];
    for (const element of originalInnerElements) {
      toReturn.innerElements.push(this.duplicateSessionItem(element));
    }
    toDuplicate.innerElements = originalInnerElements;

    switch (toReturn.type) {

      case SessionItemsProvider.TYPE_BLOC:

        toReturn.id = 0;
        toReturn.data.id = 0;

        break;

      case SessionItemsProvider.TYPE_REST:

        toReturn.id = 0;
        toReturn.data.id = 0;

        break;

      case SessionItemsProvider.TYPE_COMMENT:

        toReturn.id = 0;
        toReturn.data.id = 0;

        break;

      case SessionItemsProvider.TYPE_EXERCICE:

        toReturn.id = 0;
        // toReturn.data.sessionItemExercice.id = 0;
        break;

      default:

        break;

    }

    return toReturn;
  }

  public getEmptyItemExercice(exercice: ExerciceRow, ord = 0, parentId = 0): SessionItemRow {

    return {
      parentId,
      id: 0,
      ord,
      type: SessionItemsProvider.TYPE_EXERCICE,
      data: {
        exercice,
        sessionItemExercice: {
          id: 0,
          exerciceId: exercice.exercice.id,
          sessionItemWrapperId: 0,
          nbRepeat: 0,
          duration: 0,
          nbSerie: 0,
          payload: 0,
          restTime: 0,
          comment: '',
          ord: 0,
          createDate: '',
          createrId: 0,
          updateDate: '',
          updaterId: 0,
          deleteDate: '',
          deleterId: 0
        }
      },
      innerElements: []
    };

  }

  public getEmptyItem(type: string, ord = 0, parentId = 0): SessionItemRow {

    let dataToSet = {};

    switch (type) {

      case SessionItemsProvider.TYPE_BLOC:
        dataToSet = {
          nbRepeat: 1
        };
        break;

      case SessionItemsProvider.TYPE_REST:
        dataToSet = {
          restTime: 0
        };
        break;

      case SessionItemsProvider.TYPE_COMMENT:
        dataToSet = {
          comment: ''
        };
        break;

      default:
        dataToSet = {};
        break;

    }

    return {
      parentId: 0,
      id: 0,
      ord,
      type,
      data: dataToSet,
      innerElements: []

    };

  }


  /***
   CODE DE TRANSFORMATION DES DONNEES APRES CHARGEMENT ENTIER DE LA SESSION "/expanded"
   ***/
  public buildSessionItemRowsFromSession(
    organization: Organization,
    session: Session
  ): Observable<SessionItemRow[]> {
    const rows: SessionItemRow[] = [];
    // Nous allons accumuler pour chaque wrapper un Observable qui met à jour la ligne (SessionItemRow)
    const asyncObservables: Observable<SessionItemRow>[] = [];

    // Parcourir chaque wrapper présent dans la session (si défini)
    session.sessionItemWrappers?.forEach(wrapper => {
      // On extrait les propriétés qu'on ne souhaite pas inclure directement dans data
      const { sessionItems, sessionItemExercises, ...filteredData } = wrapper;

      // Créer la ligne principale pour le wrapper
      const row: SessionItemRow = {
        id: wrapper.id,
        ord: wrapper.ord,
        type: wrapper.type,
        data: filteredData,
        innerElements: [],
        isCollapsed: false,
      };

      // 1. Traiter les éléments non-exercices (pauses, commentaires, etc.)
      if (sessionItems && sessionItems.length > 0) {
        sessionItems.forEach(item => {
          row.innerElements.push({
            id: item.id,
            parentId: item.sessionItemWrapperId,
            type: item.type, // par exemple "REST" ou "COMMENT"
            ord: item.ord,
            data: item,
            innerElements: [],
            isCollapsed: false,
          });
        });
      }

      // 2. Traiter les exercices via e_toExerciceRow (de façon asynchrone)
      if (sessionItemExercises && sessionItemExercises.length > 0) {
        // Pour chaque exercice dans le wrapper...
        const exerciseObservables: Observable<SessionItemRow | null>[] = sessionItemExercises.map(ex => {
          // Récupérer l'objet d'exercice (qui peut être sous "exercise" ou "exercice")
          const exerciceFlat = ex.exercise;
          // Éliminer la duplication en retirant la propriété "exercise" du sessionItemExercice
          const { exercise, ...sessionItemExerciceClean } = ex;
          if (!exerciceFlat) {
            return of(null);
          }
          return this._exercicesProvider.e_toExerciceRow(organization, exerciceFlat, true, true, false).pipe(
            map((exerciceRow: ExerciceRow) => {
              return {
                id: ex.id,
                parentId: ex.sessionItemWrapperId,
                type: SessionItemsProvider.TYPE_EXERCICE, // ou "EXERCICE"
                ord: ex.ord,
                data: {
                  sessionItemExercice: sessionItemExerciceClean,
                  exercice: exerciceRow  // déjà structuré par e_toExerciceRow
                },
                innerElements: [],
                isCollapsed: false,
              } as SessionItemRow;
            })
          );
        });
        // Utiliser forkJoin pour combiner les observables et filtrer les éventuels nulls
        const combinedExercises$ = forkJoin(exerciseObservables).pipe(
          map((exerciseRows: (SessionItemRow | null)[]) => {
            // Filtrer les valeurs nulles grâce à un garde-type
            const validExerciseRows = exerciseRows.filter((r): r is SessionItemRow => r !== null);
            // Fusionner les exercices avec les autres innerElements
            row.innerElements = row.innerElements.concat(validExerciseRows);
            return row;
          })
        );
        asyncObservables.push(combinedExercises$);
      }

      rows.push(row);
    });

    // Si aucun traitement asynchrone n'est nécessaire, on renvoie immédiatement rows
    const allAsync$: Observable<any> =
      asyncObservables.length > 0 ? forkJoin(asyncObservables) : of(null);

    // Une fois que tous les observables asynchrones sont terminés, on trie les innerElements et les wrappers
    return allAsync$.pipe(
      map(() => {
        // Tri de chaque groupe d'éléments internes par leur "ord"
        rows.forEach(r => {
          r.innerElements.sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0));
        });
        // Tri global des wrappers par "ord"
        rows.sort((a, b) => (a.ord ?? 0) - (b.ord ?? 0));
        return rows;
      })
    );
  }


  public listSessionItemRows(organization: Organization, sessionId: number, fetchInnerElements = true, withTrashed: boolean = false): Observable<SessionItemRow[]> {

    if (sessionId === 0) {
      return of([]);
    }

    return this.getSessionItemWrappers(sessionId, withTrashed).pipe(
      switchMap((sessionItemWrappers: SessionItemWrapper[]) => {
        const sessionItemRows: SessionItemRow[] = [];
        const observables: Observable<SessionItemRow[]>[] = [];

        sessionItemWrappers.forEach((sessionItemWrapper) => {
          const row: SessionItemRow = {
            parentId: undefined,
            id: sessionItemWrapper.id,
            ord: sessionItemWrapper.ord,
            type: sessionItemWrapper.type,
            data: sessionItemWrapper,
            innerElements: [],
          };
          if (sessionItemWrapper.type === SessionItemWrapper.TYPE_BLOC && fetchInnerElements) {
            observables.push(this.getSessionItems(sessionItemWrapper.id!, withTrashed));
            observables.push(this.getSessionItemExercices(organization, sessionItemWrapper.id!, withTrashed));
          }
          sessionItemRows.push(row);
        });

        if (observables.length === 0) {
          return of(sessionItemRows);
        }

        return forkJoin(observables).pipe(
          switchMap((innerElementsArray: SessionItemRow[][]) => {
            innerElementsArray.forEach((innerElements) => {
              innerElements.forEach((innerElement) => {
                const parent = sessionItemRows.find(row => row.id === innerElement.parentId);
                parent?.innerElements.push(innerElement);
              });
            });

            sessionItemRows.forEach((row) => {
              if (row.innerElements.length > 0) {
                row.innerElements.sort((a, b) => a.ord! - b.ord!);
              }
            });

            sessionItemRows.sort((a, b) => a.ord! - b.ord!);

            const exercices = this.getSessionItemExercicesFromSessionItemRows(sessionItemRows);
            const mediaObservables = exercices.map(exercice =>
              this._exercicesProvider.getImageFile(organization.id!, exercice.data.exercice)
            );

            return forkJoin(mediaObservables).pipe(
              map((medias) => {
                for (let i = 0; i < exercices.length; i++) {
                  exercices[i].data.exercice.exerciceImage = medias[i];
                }
                return sessionItemRows;
              })
            );
          }),
          map(result => result),
          catchError((error) => {
            console.error(error);
            return of(sessionItemRows);
          }),
        );
      })
    );
  }


  // SD
  // Carefull there, recursive function.
  public getSessionItemExercicesFromSessionItemRows(sessionItemRows: SessionItemRow[]): SessionItemRow[] {

    let toReturn: SessionItemRow[] = [];

    sessionItemRows.forEach((sessionItemRow) => {

      switch (sessionItemRow.type) {
        case SessionItemsProvider.TYPE_BLOC:
          toReturn = toReturn.concat(this.getSessionItemExercicesFromSessionItemRows(sessionItemRow.innerElements));
          break;
        case SessionItemsProvider.TYPE_EXERCICE:
          toReturn.push(sessionItemRow);
          break;
        default:
          return;
      }

    });

    return toReturn;

  }

  // SD
  // Carefull there, recursive function.
  public getSessionItemFromSessionItemRows(sessionItemsRows: SessionItemRow[], types: string[]): SessionItemRow[] {

    let toReturn: SessionItemRow[] = [];

    sessionItemsRows.forEach((sessionItemsRow) => {

      if (types.indexOf(sessionItemsRow.type!) > -1) {
        toReturn.push(sessionItemsRow);
        return;
      }

      if (sessionItemsRow.type === SessionItemsProvider.TYPE_BLOC) {
        toReturn = toReturn.concat(this.getSessionItemFromSessionItemRows(sessionItemsRow.innerElements, types));
        return;
      }

    });

    return toReturn;

  }

  public getSessionItemExercicesFromSession(organization: Organization, sessionId: number): Promise<SessionItemRow[]> {
    throw new Error("Method not implemented.");
    // return new Promise((resolve, reject) => {
    //     this.getSessionExercices(sessionId)
    //         .then((sessionItemExercices) => {
    //
    //             return this.sie_toSessionItemRow(organization, sessionItemExercices)
    //
    //         });
    //
    // });

  }

  // SD
  // Carefull there, recursive function.
  public getTotalTime(sessionItemRows: SessionItemRow[]): number {

    let toReturn = 0;

    sessionItemRows.forEach((sessionItemRow) => {

      switch (sessionItemRow.type) {

        case SessionItemsProvider.TYPE_BLOC:
          const totalBloc = this.getTotalTime(sessionItemRow.innerElements);
          toReturn += (totalBloc * sessionItemRow.data.nbRepeat);
          break;

        case SessionItemsProvider.TYPE_EXERCICE:
          toReturn += this.getTotalTime_Exercice(sessionItemRow);
          break;

        case SessionItemsProvider.TYPE_REST:
          toReturn += sessionItemRow.data.restTime;
          break;

        default:
          break;

      }

    });

    return toReturn;

  }

  public getTotalTime_Exercice(sessionItemRow: SessionItemRow): number {

    let toReturn = 0;

    switch (sessionItemRow.data.exercice.exercice.exerciceType) {

      case Exercice.TYPE_DURATION:
        toReturn += (sessionItemRow.data.sessionItemExercice.nbRepeat * (sessionItemRow.data.sessionItemExercice.restTime + sessionItemRow.data.sessionItemExercice.duration));
        break;

      case Exercice.TYPE_REPEAT:
        toReturn += (
          (
            sessionItemRow.data.sessionItemExercice.nbSerie
            * sessionItemRow.data.sessionItemExercice.nbRepeat
            * sessionItemRow.data.sessionItemExercice.duration
          )
          +
          (
            sessionItemRow.data.sessionItemExercice.nbSerie
            * sessionItemRow.data.sessionItemExercice.restTime
          )
        );
        break;

      default:
        break;

    }

    return toReturn;

  }

  public getAdnInfos(sessionItemRows: SessionItemRow[], mode = 'timelined', nbRepeat = 1): AdnRow[] {
    let infos = [];

    switch (mode) {
      case 'resumed':
        infos = this.getAdnInfos_resumed(sessionItemRows, nbRepeat);
        break;
      default:
      case 'timelined':
        infos = this.getAdnInfos_timelined(sessionItemRows, nbRepeat);
        break;
    }

    // take session repeat into account
    let adn: any[] = [];
    for (let i = 0; i < nbRepeat; i++) {
      adn = [...adn, ...infos];
    }

    return adn;
  }

  public getAdnInfos_timelined(sessionItemRows: SessionItemRow[], nbRepeat = 1): AdnRow[] {
    let toReturn: AdnRow[] = [];
    let blocAdnRows: AdnRow[] = [];
    let totalTime = 0;
    let totalTimeBloc = 0;
    let tmpTime = 0;

    sessionItemRows.forEach((sessionItem) => {
      if (sessionItem.type !== SessionItemsProvider.TYPE_BLOC) {
        return;
      }
      blocAdnRows = [];
      totalTimeBloc = 0;

      // Calc values for current bloc

      sessionItem.innerElements.forEach((sie) => {

        if (sie.type !== SessionItemsProvider.TYPE_EXERCICE) {
          return;
        }

        tmpTime = this.getTotalTime_Exercice(sie) / sie.data.exercice.categories.filter((cat:any) => cat !== null).length;

        sie.data.exercice.categories.forEach((category: any) => {

          if (category === null) {
            return;
          }

          blocAdnRows.push({
            exerciceCategory: category,
            percentage: tmpTime
          });

          totalTimeBloc += tmpTime;

        });

      });

      // Merge values for this current bloc with the total to return

      totalTime += (totalTimeBloc * sessionItem.data.nbRepeat);

      for (let i = 0; i < sessionItem.data.nbRepeat; i++) {

        toReturn = toReturn.concat(JSON.parse(JSON.stringify(blocAdnRows)));

      }

    });

    let totalPercentage = 0;

    toReturn.forEach((adn) => {
      adn.percentage = (100 * adn.percentage / totalTime) / nbRepeat;
      totalPercentage += adn.percentage;
    });

    return toReturn;

  }

  public getAdnInfos_resumed(sessionItemRows: SessionItemRow[], nbRepeat = 1): AdnRow[] {

    const toReturn: AdnRow[] = [];
    let totalTime = 0;
    let tmp: AdnRow | undefined;
    let tmpTime = 0;

    sessionItemRows.forEach((sessionItem) => {

      if (sessionItem.type !== SessionItemsProvider.TYPE_BLOC) {
        return;
      }

      sessionItem.innerElements.forEach((sie) => {

        if (sie.type !== SessionItemsProvider.TYPE_EXERCICE) {
          return;
        }

        sie.data.exercice.categories.forEach((category: any) => {

          if (category === null) {
            return;
          }

          tmp = toReturn.find((adn) => adn.exerciceCategory.id === category.id);

          tmpTime = this.getTotalTime_Exercice(sie) * sessionItem.data.nbRepeat;

          if (typeof(tmp) === 'undefined') {

            tmp = {
              exerciceCategory: category,
              percentage: tmpTime
            };

            toReturn.push(tmp);

          } else {

            tmp.percentage += tmpTime;

          }

          totalTime += tmpTime;

        });

      });

    });

    toReturn.forEach((adn) => {
      adn.percentage = (100 * adn.percentage / totalTime) / nbRepeat;
    });

    toReturn.sort((a, b) => {

      if (a.percentage < b.percentage) {
        return 1;
      }
      if (a.percentage > b.percentage) {
        return -1;
      }
      return 0;

    });

    return toReturn;

  }

  public saveSessionItemRows(organizationId: number, sessionId: number, sessionItemRows: SessionItemRow[], sessionRow: SessionRow, langs: number[] = []): Observable<Session> {
    // Dirty Clone for Dirty Process is Drity
    const toSave: {sessionItemRows: any; sessionRow: any; item: any; translations: any; langs?: number[]} = {sessionItemRows: null, sessionRow: null, item: null, translations: null};

    toSave.sessionRow = sessionRow;
    // this is to avoid having libraryId typed null in sessionRow, API needs null, 0 or undefined can't be ok
    if (sessionRow.libraryId === 0) {
      toSave.sessionRow.libraryId = null;
    }

    toSave.sessionItemRows = JSON.parse(JSON.stringify(sessionItemRows, (key: string, value: any) => {
      // pour �viter les circular error: https://stackoverflow.com/questions/11616630/json-stringify-avoid-typeerror-converting-circular-structure-to-json
      if (key == 'rights') {
        return;
      }

      return value;
    }));

    // If no languages are provided, the API will automatically complete it with the user's language.
    toSave.langs = langs;

    this.preSave(toSave.sessionItemRows);

    // we send data serialized as the maximum allowed number of inputs is limited to 1000
    // and it can easily be reached by large sessions
    return this.api.call('post', `organizations/${organizationId}/session-items/${sessionId}/save`,
      toSave,
      this._currentUser.getAccessToken()
    ).pipe(
      map((result) => { // retour bizarre : data, session, sessionTranslations
        const session = result.session;
        session.translations = result.sessionTranslations;
        return Session.fromAPI(session);
      }),
    );
  }

  public getHistogramData(session: SessionRow|any): HistogramData | null {
    if (session.adn === null || session.adn.length === 0) {
      return null;
    }

    const toReturn: HistogramData = {
      rows: [],
      cols: [],
      values: []
    };

    toReturn.rows.push({
      id: session.id,
      image: '',
      title: session.name,
      subTitle: ''
    });

    session?.adn?.forEach((a: any, index: any) => {

      toReturn.cols.push({
        id: index,
        title: a.exerciceCategory.name,
        color: a.exerciceCategory.colorHex
      });

      toReturn.values.push({
        rowId: session.id,
        columnId: index,
        value: a.percentage,
        item: a.exerciceCategory
      });

    });

    return toReturn;

  }

  private toSessionRow(session: Session, creater: User, rights: SessionItemRightsList): SessionRow {

    const toReturn: SessionRow = {
      id: session.id,
      libraryId: session.libraryId,
      type: session.type,
      name: session.name,
      tags: session.tags,
      totalTime: session.totalTime,
      intensity: session.intensity,
      nbRepeat: session.nbRepeat,
      comment: session.comment,
      adn: JSON.parse(session.adn!),
      creater,
      rights,
      availableLangIds: session.availableLangIds,
      histogramData: null
    };

    toReturn.histogramData = this.getHistogramData(toReturn);

    return toReturn;
  }

  toSession(sessionRow: SessionRow): Session {
    return new Session({
      id: sessionRow.id,
      libraryId: sessionRow.libraryId,
      type: sessionRow.type,
      name: sessionRow.name,
      tags: sessionRow.tags,
      nbRepeat: sessionRow.nbRepeat,
      intensity: sessionRow.intensity,
      totalTime: sessionRow.totalTime,
      comment: sessionRow.comment,
      availableLangIds: sessionRow.availableLangIds,
      adn: JSON.stringify(sessionRow.adn),
    });
  }

  // SD
  // Carefull there, recursive function.
  private preSave(sessionItemRows: any[]) {

    // Remove all files linked to the exercice in order to save all the structure.

    sessionItemRows.forEach((sessionItemRow) => {

      switch (sessionItemRow.type) {
        case SessionItemsProvider.TYPE_BLOC:
          this.preSave(sessionItemRow.innerElements);
          break;
        case SessionItemsProvider.TYPE_EXERCICE:
          sessionItemRow.data.exercice.exerciceImage = null;
          sessionItemRow.data.exercice.exerciceVideo = null;
          break;
        default:
          return;
      }

    });

  }

  private clearSessionItems(organizationId: number, sessionId: number): Observable<void> {
    return this.api.call(                'get',
      'organizations/' + organizationId + '/sessionitems/' + sessionId + '/clear',
      {},
      this._currentUser.getAccessToken()
    ).pipe(
      map((res: any) => {
        return res;
      }),
    );
  }

  private clearSessionItems_localStorageOnly(sessionId: number): Promise<any> {
    throw new Error("Method not implemented.");
    //
    //     return new Promise<any>((resolve, reject) => {
    //
    //         this.getSessionItemWrappers(sessionId)
    //             .then((itemWrappers) => {
    //
    //                 const sessionItemsToFetch: Array<Promise<SessionItem>> = [];
    //                 const sessionItemExercicesToFetch: Array<Promise<SessionItemExercice>> = [];
    //
    //                 itemWrappers.forEach((itemWrapper) => {
    //                     sessionItemsToFetch.push(
    //                         this.getSessionItemByWrapper(itemWrapper.id!)
    //                     );
    //
    //                     sessionItemExercicesToFetch.push(
    //                         this.getSessionItemExerciceByWrapper(itemWrapper.id!)
    //                     );
    //
    //                 });
    //
    //                 // Unused after removing them from storage?
    //                 Promise.all(sessionItemsToFetch)
    //                     .then((sessionItems) => {
    //
    //                         Promise.all(sessionItemExercicesToFetch)
    //                             .then((sessionItemExercices) => {
    //
    //                                 Promise.all([
    //                                     // this._storage.delete(sessionItems),
    //                                     // this._storage.delete(sessionItemExercices),
    //                                     // this._storage.delete(itemWrappers)
    //                                 ])
    //                                     .then(resolve)
    //                                     .catch(reject);
    //
    //                             })
    //                             .catch(reject);
    //
    //                     })
    //                     .catch(reject);
    //
    //             })
    //             .catch(reject);
    //
    //     });
    //
  }

  private getSessionItemWrappers(sessionId: number, withTrashed: boolean = false): Observable<SessionItemWrapper[]> {
    return this.getSessionItemWrappersBySession(sessionId, withTrashed);

  }

  private getSessionItems(itemWrapperId: number, withTrashed: boolean = false): Observable<SessionItemRow[]> {
    return this.getSessionItemsByWrapper(itemWrapperId, withTrashed).pipe(
      map((sessionItems: SessionItem[]) => this.si_toSessionItemRow(sessionItems)),
    )
  }

  private getSessionItemExercices(organization: Organization, itemWrapperId: number, withTrashed: boolean = false): Observable<SessionItemRow[]> {

    return this.getSessionItemExercicesByWrapper(itemWrapperId, withTrashed).pipe(
      switchMap((sessionItemExercices: SessionItemExercice[]) => this.sie_toSessionItemRow(organization, sessionItemExercices)),
    );
  }

  private si_toSessionItemRow(sessionItems: SessionItem[]): SessionItemRow[] {

    const toReturn: SessionItemRow[] = [];

    sessionItems.forEach((sessionItem) => {

      toReturn.push({
        id: sessionItem.id,
        parentId: sessionItem.sessionItemWrapperId,
        type: sessionItem.type,
        ord: sessionItem.ord,
        data: sessionItem,
        innerElements: []
      });

    });

    return toReturn;

  }

  private sie_toSessionItemRow(organization: Organization, sessionItemExercices: SessionItemExercice[]): Observable<SessionItemRow[]> {
    const exerciceObservables: Observable<ExerciceRow>[] = [];
    const toReturn: SessionItemRow[] = [];

    sessionItemExercices.forEach((sie) => {
      exerciceObservables.push(this._exercicesProvider.getExerciceRow(organization, sie.exerciceId!, false, false));
    });

    if (exerciceObservables.length === 0) {
      return of([]);
    }

    return forkJoin(exerciceObservables).pipe(
      map((exerciceRows: ExerciceRow[]) => {
        try {
          sessionItemExercices.forEach((sessionItemExercice) => {
            toReturn.push({
              id: sessionItemExercice.id,
              parentId: sessionItemExercice.sessionItemWrapperId,
              type: SessionItemExercice.TYPE_EXERCICE,
              ord: sessionItemExercice.ord,
              data: {
                sessionItemExercice,
                exercice: exerciceRows.find((row) => row.exercice.id === sessionItemExercice.exerciceId)
              },
              innerElements: []
            });
          });
          return toReturn;
        } catch (error) {
          console.error(error);
          return [];
        }
      }),
    );
  }

  private getDistinctMedia(organizationId: number, sessionItemRows: SessionItemRow[]): Promise<MediaRow[]> {
    return new Promise((resolve, reject) => {

      const toReturn: MediaRow[] = [];

      // Select distinct SessionItemRow, according to their exercice setted in data field

      const distinctSessionItemRow_exercice: SessionItemRow[] = [];

      sessionItemRows.forEach((sessionItemRow) => {

        const found = distinctSessionItemRow_exercice.find((d) => d.data.exercice.exercice.id === sessionItemRow.data.exercice.exercice.id);

        if (!found) {
          distinctSessionItemRow_exercice.push(sessionItemRow);
        }

      });

      const toFetch: Array<Observable<any>> = [];

      distinctSessionItemRow_exercice.forEach((d) => {

        toFetch.push(this._exercicesProvider.getImageFile(organizationId, d.data.exercice));
        // on preload pas les vid�o, c'est trop gourmand ...
        // toFetch.push(this._exercicesProvider.getVideoFile(organizationId, d.data.exercice));

      });

      forkJoin(toFetch).pipe(
        map((data: any[]) => {
          distinctSessionItemRow_exercice.forEach((d, index) => {
            toReturn.push({
              exerciceId: d.data.exercice.exercice.id,
              image: data[2 * index],
              // video: data[(2 * index) + 1]
              video: null
            });
          });
          resolve(toReturn);
        })
      );
    });
  }
}

export interface SavedSessionItemRow {

  type: string;
  savedValue: any;
  sessionItemRow: SessionItemRow;

}

export interface SessionItemRow {
  id?: number;
  parentId?: number;
  parentIndex?: number;
  type?: string;
  ord?: number;
  data?: any;
  innerElements: SessionItemRow[];
  isCollapsed?: boolean;
}

export interface MediaRow {
  exerciceId: number;
  image: any;
  video: any;
}

export interface SessionItemExerciceRow {

  sessionItemExercice: SessionItemExercice;
  exercice: ExerciceRow;

}

export interface AdnRow {
  exerciceCategory: ExerciceCategory;
  percentage: number;
}
